import { render, staticRenderFns } from "./MajorityTable.vue?vue&type=template&id=f914ff3c&"
import script from "./MajorityTable.vue?vue&type=script&lang=js&"
export * from "./MajorityTable.vue?vue&type=script&lang=js&"
import style0 from "./MajorityTable.vue?vue&type=style&index=0&id=f914ff3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports